var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0181 1.18501C12.8868 1.04745 12.729 0.937959 12.5542 0.863151C12.3793 0.788342 12.1911 0.749771 12.001 0.749771C11.8108 0.749771 11.6226 0.788342 11.4478 0.863151C11.2729 0.937959 11.1151 1.04745 10.9838 1.18501L1.14002 11.4975C0.949869 11.6966 0.822344 11.9471 0.773261 12.2181C0.724178 12.489 0.755697 12.7683 0.863908 13.0215C0.97212 13.2746 1.15226 13.4905 1.382 13.6422C1.61173 13.7939 1.88095 13.8749 2.15627 13.875H4.50002V21.375C4.50002 21.8723 4.69757 22.3492 5.0492 22.7008C5.40083 23.0525 5.87774 23.25 6.37502 23.25H8.25002C8.7473 23.25 9.22421 23.0525 9.57585 22.7008C9.92748 22.3492 10.125 21.8723 10.125 21.375V19.5C10.125 19.0027 10.3226 18.5258 10.6742 18.1742C11.0258 17.8226 11.5027 17.625 12 17.625C12.4973 17.625 12.9742 17.8226 13.3258 18.1742C13.6775 18.5258 13.875 19.0027 13.875 19.5V21.375C13.875 21.8723 14.0726 22.3492 14.4242 22.7008C14.7758 23.0525 15.2527 23.25 15.75 23.25H17.625C18.1223 23.25 18.5992 23.0525 18.9508 22.7008C19.3025 22.3492 19.5 21.8723 19.5 21.375V13.875H21.8438C22.1192 13.8752 22.3887 13.7945 22.6187 13.643C22.8488 13.4914 23.0292 13.2756 23.1376 13.0223C23.2461 12.7691 23.2778 12.4896 23.2287 12.2185C23.1797 11.9474 23.0522 11.6967 22.8619 11.4975L13.0181 1.18501Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHome);
export default __webpack_public_path__ + "static/media/menu-home.c51f11be76f95a7496910fecd6123b00.svg";
export { ForwardRef as ReactComponent };